import React, { useState } from 'react'

import { Card, CardContent, CardHeader, Step, StepButton, StepLabel, Stepper } from '@mui/material'
import { useParams } from 'react-router-dom'

import { BannersReview, DataReview, ExchangeCreate } from 'components/campaign-review'
import LoadingView from 'components/LoadingView'
import { StepContent } from 'components/stepper'
import { useCampaignReview } from 'hooks/useCampaignReview'

const CampaignReview = () => {
  const { id } = useParams()
  const { isLoading, error } = useCampaignReview(id)
  const [active, setActive] = useState(0)

  const changePage = (page: number) => () => setActive(page)

  const config: any[] = [
    { title: 'Campaign Review', next: changePage(1), direct: changePage(0), component: DataReview },
    {
      title: 'Banners management',
      back: changePage(0),
      next: changePage(2),
      direct: changePage(1),
      component: BannersReview,
    },
    { title: 'Create campaign in exchange', back: changePage(1), component: ExchangeCreate },
  ]

  return (
    <div>
      <Card>
        <CardHeader title="Campaign Review" />
        <CardContent>
          <Stepper activeStep={active} nonLinear>
            {config.map((item, index) => {
              const StepHeader = item.direct ? StepButton : StepLabel
              return (
                <Step key={index}>
                  {/* eslint-disable-next-line react/jsx-handler-names */}
                  <StepHeader onClick={item.direct}>{item.title}</StepHeader>
                </Step>
              )
            })}
          </Stepper>
          <LoadingView error={error ? 'Campaign data load error' : undefined} loading={isLoading}>
            <StepContent {...config[active]} />
          </LoadingView>
        </CardContent>
      </Card>
    </div>
  )
}

export default CampaignReview
